module.exports = __webpack_public_path__ + "img/约会达人聊天气泡.6573acf2.png";